import { Building2, Contact } from 'lucide-react';
import { email, nomeParceiro } from '../../nucleo/formato';
import type { FonteBuscaGlobal } from '../../nucleo/modulos-web';
import { CAMINHO_CONTATOS, CAMINHO_EMPRESAS } from './crm-comum';

/**
 * CRM no novo desenho, lote 6 (N8): empresas e contatos (pessoas) na busca da barra superior, pela lista de sempre
 * (`/cadastros/parceiros`, papel `empresa` ou `contato`). O nome e o e-mail passam pelo modo discreto. Os títulos dos grupos
 * são os do filtro por papel, que já existem nos três idiomas. Rodada crm1 (SPEC-M1): abrem as páginas do CRM
 * (`/crm/empresas/:id` e `/crm/contatos/:id`), como no clone do RD. Lista de 30/10 (item 10): a consulta é a do servidor
 * (`r.buscaGlobal` do Cadastros, a mesma rota), que casa também código, documento, e-mail e telefone; "Ver todos" abre a lista
 * do CRM com a busca (as duas leem `?busca=`).
 */
interface Parceiro {
  id: string;
  nome: string;
  email: string | null;
}

const fonte = (papel: 'empresa' | 'contato'): FonteBuscaGlobal<Parceiro> => {
  const base = papel === 'empresa' ? CAMINHO_EMPRESAS : CAMINHO_CONTATOS;
  return {
    chave: papel === 'empresa' ? 'empresas' : 'contatos',
    permissao: 'cadastros.ver',
    pagina: 'cadastros.pessoas',
    grupo: `filtros.${papel}`,
    posicao: papel === 'contato' ? 20 : 30,
    icone: papel === 'empresa' ? Building2 : Contact,
    item: (p) => ({ id: p.id, rotulo: nomeParceiro(p.nome), detalhe: p.email ? email(p.email) : undefined, link: `${base}/${p.id}` }),
    verTodos: (termo) => `${base}?busca=${encodeURIComponent(termo)}`,
  };
};

export const buscaCadastros: FonteBuscaGlobal[] = [fonte('contato'), fonte('empresa')];
